import { render, staticRenderFns } from "./parques.vue?vue&type=template&id=2a3acb93&scoped=true&"
import script from "./parques.vue?vue&type=script&lang=js&"
export * from "./parques.vue?vue&type=script&lang=js&"
import style0 from "./parques.vue?vue&type=style&index=0&id=2a3acb93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3acb93",
  null
  
)

export default component.exports